export default __webpack_public_path__ + "static/p1-4666cecb29aa0b6ee0582d918f3b9310.png";